import type { Rng } from '../rng';
import type { Action, BotDifficulty, PlayerView } from '../types';
import { chooseEasy } from './easy';
import { chooseNormal } from './normal';

/**
 * Escolhe uma ação para o bot. O bot só enxerga a própria PlayerView e só
 * escolhe entre as ações de `legal`, então nunca trava o jogo.
 */
export function chooseAction(
  view: PlayerView,
  legal: Action[],
  rng: Rng,
  difficulty?: BotDifficulty,
): Action {
  if (legal.length === 0) throw new Error('bot sem ações legais');
  if (view.me === null) throw new Error('bot sem lugar');
  const level = difficulty ?? view.players[view.me].difficulty ?? 'normal';
  const choice = level === 'easy' ? chooseEasy(view, legal, rng) : chooseNormal(view, legal, rng);
  return choice ?? legal[0];
}

export { chooseEasy, chooseNormal };
export * from './heuristics';
